var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoJeepVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 64 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.093,
    cy: 32.093,
    r: 20.093,
    fill: "#008000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6001 28.2H42.0002C41.7793 28.2 41.6002 28.3792 41.6002 28.6001V29.1149L41.0825 27.95C40.825 27.3727 40.2524 27.0007 39.6201 27H29.5061C28.9245 26.9997 28.3884 27.3148 28.106 27.8232L26.5552 30.6144L21.4984 30.9304C20.6564 30.9852 20.0011 31.6835 20 32.5272V35.4001C20 35.621 20.179 35.8 20.4001 35.8H21.2319C21.4515 37.3288 22.8688 38.39 24.3975 38.1705C25.6263 37.9941 26.5915 37.0287 26.768 35.8H35.232C35.4516 37.3288 36.8689 38.39 38.3976 38.1705C39.6263 37.9941 40.5916 37.0287 40.768 35.8H42.0002C42.221 35.8 42.4001 35.621 42.4001 35.4001V33.8H43.6001C43.821 33.8 44 33.621 44 33.4001V28.6001C44.0002 28.3791 43.8211 28.2 43.6001 28.2ZM24 37.4001C22.8954 37.4001 22 36.5046 22 35.4001C22 34.2955 22.8954 33.4001 24 33.4001C25.1045 33.4001 26 34.2955 26 35.4001C25.9987 36.5041 25.104 37.3988 24 37.4001ZM32.0001 30.6001H27.48L28.8074 28.2116C28.9483 27.9579 29.2157 27.8003 29.5061 27.8H32.0001V30.6001ZM38.0001 37.4001C36.8955 37.4001 36.0001 36.5046 36.0001 35.4001C36.0001 34.2955 36.8955 33.4001 38.0001 33.4001C39.1048 33.4001 40.0001 34.2955 40.0001 35.4001C39.9988 36.5041 39.1041 37.3988 38.0001 37.4001ZM43.2002 33H42.4002V29H43.2002V33Z",
    fill: "#FBFDFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 3,
    y: 5,
    width: 60.186,
    height: 60.186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoJeepVerde);
export default __webpack_public_path__ + "static/media/iconoJeepVerde.cec139219464e460b0e18c25dacb8bf0.svg";
export { ForwardRef as ReactComponent };